function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "logo-variant-1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Polygon2",
  d: "M29.41 116.05L107.183 6.4743L163.778 115.24L29.41 116.05Z",
  fill: "#6C0E8D"
}), /*#__PURE__*/React.createElement("path", {
  id: "Polygon1",
  d: "M28.0491 116.989L136.871 32.711L165.68 115.349L28.0491 116.989Z",
  fill: "#BB75CC"
}));

var SvgLogoVariant1 = function SvgLogoVariant1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 177,
    viewBox: "0 0 181 177",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoVariant1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-variant-1.edae7d05.svg";
export { ForwardRef as ReactComponent };